import * as React from "react";
import { StandardProps } from "@material-ui/core";
import { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import MuiTableSortLabel, { TableSortLabelClassKey as MuiTableSortLabelClassKey } from "@material-ui/core/TableSortLabel";




export type TableSortLabelClassKey = MuiTableSortLabelClassKey;

export interface TableSortLabelProps extends StandardProps<ButtonBaseProps, TableSortLabelClassKey> {
    active?: boolean;
    direction?: 'asc' | 'desc';
    hideSortIcon?: boolean;
    IconComponent?: React.ComponentType<SvgIconProps>;
}

class TableSortLabel extends React.PureComponent<TableSortLabelProps>{

    render() {
        const { ...props } = this.props;

        return <MuiTableSortLabel {...props}>
            {this.props.children}
        </MuiTableSortLabel>
    }
}

export default TableSortLabel;

